export default "__VITE_ASSET__2463d07a__"